import { useState } from "react";

import { RequisitionsQueryOptions } from "./RequisitionsQueryOptions";
import { RequisitionsTable } from "./RequisitionsTable";

import { defaultRequisitionQueryParams } from "@/lib/constants";
import { Column } from "@/components";
import { cn } from "@/lib/utils";
import { Job, RequisitionQueryParams } from "@/types";

export const Requisitions = ({
  className,
  job,
}: {
  className?: string;
  job: Job;
}) => {
  /* React Hooks */
  // useStates
  const [requisitionQueryParams, setRequisitionQueryParams] =
    useState<RequisitionQueryParams>(defaultRequisitionQueryParams);

  return (
    <Column className={cn("gap-2", className)}>
      <RequisitionsQueryOptions
        requisitionQueryParams={requisitionQueryParams}
        setRequisitionQueryParams={setRequisitionQueryParams}
      />
      <RequisitionsTable
        job={job}
        requisitionQueryParams={requisitionQueryParams}
      />
    </Column>
  );
};
